export const BUILD_VERSION = '1779289877';
